<template>
  <aside class="nav">
    <RouterLink
      to="/"
      class="nav__logo"
    >
      <SvgCleverInsightsWecleverLogo/>
    </RouterLink>

    <nav class="nav__menu">
      <div
        class="nav__menu__group"
        v-for="(menu, group) in nav"
        :key="group"
      >
        <h3 class="nav__menu__group__heading">
          {{ group }}
        </h3>

        <ul class="nav__menu__list">
          <li
            v-for="item in menu.filter(item => item.isActive === true)"
            :key="item.path"
            class="nav__menu__list__item"
          >
            <RouterLink
              :to="item.path"
              class="nav__menu__list__item__link"
              v-tooltip="{
                theme: 'tooltip-right',
                content: item.tooltip
              }"
            >
              <div class="nav__menu__list__item__link__icon">
                <Component :is="item.icon"/>
              </div>

              <div class="nav__menu__list__item__link__label">
                {{ item.label }}
              </div>
            </RouterLink>
          </li>
        </ul>
      </div>

    </nav>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LayoutDefaultNav',

  data () {
    return {
      nav: {
        dashboards: [],

        leads: [
          {
            path: 'leads',
            label: 'Todos os leads',
            icon: 'SvgIconNavLeadsList',
            tooltip: 'Veja os detalhes de performance<br>e histórico de conversas de cada lead.',
            isActive: true
          },
          {
            path: 'leads-upload',
            label: 'Upload',
            icon: 'SvgIconNavLeadsUpload',
            tooltip: 'Faça o upload de uma nova base<br>de leads para ser contatada.',
            isActive: true
          }
        ]
      }
    }
  },

  computed: {
    ...mapGetters(['quicksightPlatforms']),

    isQuicksightIntegrated () {
      return this.$auth.user().profile === 'platform'
        && this.quicksightPlatforms.includes(this.$auth.user().platform_name);
    }
  },

  methods: {
    initializeNav () {
      this.nav.dashboards.push(
        {
          path: 'dashboard',
          label: 'Análise das conversas',
          icon: 'SvgIconChatBrightStar',
          tooltip: 'Analise as interações dos usuários<br>e obtenha insights valiosos<br>sobre seu comportamento.',
          isActive: true
        }
        /*
        {
          path: 'operational-performance',
          label: 'Performance operacional',
          icon: 'SvgIconNavOverview',
          tooltip: 'Acompanhe os principais indicadores<br>de sucesso da operação.',
          isActive: true
        },
        {
          path: 'insight-business',
          label: 'Perfil demográfico',
          icon: 'SvgIconDemographicProfile',
          tooltip: 'Descubra os padrões e perfis dos<br>clientes que mais convertem.',
          isActive: true
        }
          */
      )
    }
  },

  created () {
    this.initializeNav();
  }
}
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  width: map-get($layout-insights, 'nav-width');
  height: 100vh;
  padding: 40px 24px 56px 24px;
  background: nth($colors-custom, 1);

  &__logo {
    display: block;
    margin-bottom: 48px;

    svg {
      width: 184px;
      fill: nth($colors-custom, 6);
    }
  }

  &__menu {
    height: calc(100% - 40px);
    overflow-y: auto;

    &__group {
      &__heading {
        margin-bottom: 8px;
        color: #fff;
        font: {
          weight: 600;
          size: 12px;
        }
        text-transform: uppercase;
      }
    }

    &__list {
      &__item {
        display: block;
        margin-bottom: 8px;

        &__link {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 5px;
          padding: 8px;
          border: 2px solid transparent;
          border-radius: 8px;
          transition: all 0.2s;
          color: #fff;
          font: {
            weight: 400;
            size: 13px;
          }
          line-height: 130%;

          &:hover {
            border-color: nth($colors-custom, 14);
          }

          &.router-link-active {
            background: nth($colors-custom, 13);

            &:hover {
              border-color: transparent;
            }
          }

          &__icon {
            display: flex;
            width: 32px;
            height: 32px;
            justify-content: center;
            align-items: center;

            svg {
              fill: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
